enum DeliveryLabelsActions {
    FETCH_LIST = "deliveryLabelsFetchList",
    GET_ITEM = "deliveryLabelsGetItem",
    CREATE_ITEM = "deliveryLabelsCreateItem",
    DELETE_ITEM = "deliveryLabelsDeleteItem",
    REFRESH_LIST = "deliveryLabelsRefreshList",
    DOWNLOAD_LABEL = "deliveryLabelsDownloadLabel",
    FETCH_ORDER_DATA = "deliveryLabelsFetchOrderData",
    FETCH_COUNTRIES = "deliveryLabelsFetchCountries",
}

enum DeliveryLabelsMutation {
    SET_RENDER_UPDATE = "deliveryLabelsListRenderNeeded",
    SET_LIST_RESULT = "deliveryLabelsListResult"
}

export {DeliveryLabelsActions, DeliveryLabelsMutation};
